import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'file-encrypted-success',
  templateUrl: './file-encrypted-success.component.html',
  styleUrls: ['./file-encrypted-success.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileEncryptedSuccessComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<FileEncryptedSuccessComponent>) {}

  ngOnInit(): void {}

  closeDialog() {
    this.dialogRef.close();
  }
}
